const env =  {
    API_PROTOCOL:'https',
    API_HOST: 'api.chiavicultura.ch',
    API_PORT: '443'
}

export default env